export default {
    namespaced: true,
    state() {
        return {
            currentOrderingShip: null,
        }
    },
    mutations: {
        setCurrentOrderingShip(state, payload) {
            state.currentOrderingShip = payload
        },
    },
}
